import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { PhoneBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const PhoneNumberAField = () => {
    const value = useBrokerDetailsStore((s) => s.phoneNumberA);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.PhoneNumberA);
    return (
        <>
            <PhoneBox
                id='cPhoneNumberA'
                value={value}
                onChange={(v) => updateFields({ phoneNumberA: v })}
                label='Primary Phone'
                width={'100%'}
                required={isBroker}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
